import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RolesRequestPermissionMutationVariables = Types.Exact<{
  input: Types.RolesRequestPermissionInput;
}>;


export type RolesRequestPermissionMutation = { __typename?: 'Mutation', rolesRequestPermission?: { __typename?: 'RolesRequestPermissionPayload', ok: boolean } | null };


export const RolesRequestPermissionDocument = gql`
    mutation rolesRequestPermission($input: RolesRequestPermissionInput!) {
  rolesRequestPermission(input: $input) {
    ok
  }
}
    `;
export type RolesRequestPermissionMutationFn = Apollo.MutationFunction<RolesRequestPermissionMutation, RolesRequestPermissionMutationVariables>;

/**
 * __useRolesRequestPermissionMutation__
 *
 * To run a mutation, you first call `useRolesRequestPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRolesRequestPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rolesRequestPermissionMutation, { data, loading, error }] = useRolesRequestPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRolesRequestPermissionMutation(baseOptions?: Apollo.MutationHookOptions<RolesRequestPermissionMutation, RolesRequestPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RolesRequestPermissionMutation, RolesRequestPermissionMutationVariables>(RolesRequestPermissionDocument, options);
      }
export type RolesRequestPermissionMutationHookResult = ReturnType<typeof useRolesRequestPermissionMutation>;
export type RolesRequestPermissionMutationResult = Apollo.MutationResult<RolesRequestPermissionMutation>;
export type RolesRequestPermissionMutationOptions = Apollo.BaseMutationOptions<RolesRequestPermissionMutation, RolesRequestPermissionMutationVariables>;